import { store } from './configureStore'

export const GetPartyId = () => store.getState().user?.organizationContext?.id

export const GetCurrentProjectId = () => {
  let projectId = store.getState().project?.activeProject?.id

  if (!projectId) {
    const parsedUrl = document.location.pathname.split('/project/')
    if (parsedUrl.length > 1) {
      projectId = parsedUrl[1].split('/')[0]
    }
  }

  return projectId
}

export const GetContext = () => ({
  partyId: GetPartyId(),
  projectId: GetCurrentProjectId(),
})

export const StoreUtils = {
  GetPartyId,
  GetCurrentProjectId,
  GetContext,
}
